import { Heading, Button, Text } from "@uhg-harmony/react";

const LoggedOut = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        fontSize: 20,
      }}
    >
      <Heading level="h3">Template Studio</Heading>

      <Text>
        You are logged out, either by logout action or session has expired due
        to page idle timeout from <strong>Template Studio</strong>
      </Text>

      <Heading level="h6">
        Close the browser window or click the button below to log back into the
        application.
      </Heading>

      <Button onPress={() => (window.location.href = "/")}>Log In Again</Button>
    </div>
  );
};

export default LoggedOut;
